import $ from "jquery";
import { component } from "picoapp";

export default component((node) => {
  $(".js-accordion-toggle").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).next(".js-accordion-body").slideUp();
    } else {
      // First close all accordians
      $(".js-accordion-toggle").removeClass("open");
      $(".js-accordion-body").slideUp("open");
      // Open the click accordian
      $(this).addClass("open");
      $(this).next(".js-accordion-body").slideDown();
    }
  });
});
